import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { LiquidityOverviewDto } from '../../../app/api/generated/client';
import { getLiquidityOverview } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useLiquidityOverview(partnerUuid?: string): UseQueryResult<LiquidityOverviewDto, AxiosError> {
    return useQuery({
        queryKey: queryKeys.liquidityOverview(partnerUuid),
        queryFn: ({ signal }) => getLiquidityOverview({ path: { partnerUuid: partnerUuid! }, signal }).then((result) => result.data),
        enabled: !!partnerUuid,
    });
}
